/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './tabs-module';
export * from './tab-group';
export {MatInkBar} from './ink-bar';
export {
  MatTabBody,
  MatTabBodyOriginState,
  MatTabBodyPositionState,
  MatTabBodyPortal
} from './tab-body';
export {MatTabHeader, ScrollDirection} from './tab-header';
export {MatTabLabelWrapper} from './tab-label-wrapper';
export {MatTab} from './tab';
export {MatTabLabel} from './tab-label';
export {MatTabNav, MatTabLink} from './tab-nav-bar/index';
export * from './tabs-animations';
